<template>
  <div class="thumbnails-container">
    <div
      v-for="thumb in thumbnails"
      :key="thumb"
      class="thumbnails-container__item"
      :style="{
        width: thumbnailSize.w + 'px',
        height: thumbnailSize.h + 'px'
      }"
    >
      <thumbnail-image
        :is-thumb="isThumb"
        :src="thumb"
        :loader-c-lose="loaderCLose"
        :fallback="$options.fallback"
        class="thumb-img"
        alt="thumbnail"
      />
    </div>
  </div>
</template>

<script>
import ThumbnailImage from "@/components/timeline/thumbnails/ThumbnailImage.vue";
import fallbackImage from "@/assets/images/empty.jpg";

// @group Timeline
// Thumbnails list
export default {
  name: "ThumbnailsRange",
  components: {
    ThumbnailImage
  },
  props: {
    /** Thumbnails sources list */
    thumbnails: {
      type: Array,
      default: () => []
    },
    loaderCLose: {
      type: Boolean,
      default: true
    },
    /** origin width & height of thumbnails */
    thumbnailSize: {
      type: Object,
      default() {
        return {
          w: 270,
          h: 155
        };
      }
    }
  },
  data() {
    return {
      isThumb: true
    };
  },
  fallback: fallbackImage
};
</script>

<style lang="scss" scoped>
.thumbnails-container {
  white-space: nowrap;
  margin: 0;
  padding: 0;
  &__item {
    display: inline-block;
  }
}

.thumb-img {
  width: 100%;
  height: 100%;
}
</style>
